import { render, staticRenderFns } from "./MaterialRadio.vue?vue&type=template&id=01b47e40&scoped=true&"
import script from "./MaterialRadio.vue?vue&type=script&lang=js&"
export * from "./MaterialRadio.vue?vue&type=script&lang=js&"
import style0 from "./MaterialRadio.vue?vue&type=style&index=0&id=01b47e40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b47e40",
  null
  
)

export default component.exports